import axios from 'axios'
import { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { constants } from '../../Constants'
import { PageLoader } from '../SpinnerLoading/SpinnerLoading'

export const MediaAgeChart = () => {
  const [chartData, setChartData] = useState([])
  const [labels, setLabels] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        // getAgeUsersChart no recibe año: es una distribución de edades sobre
        // el total de usuarios actuales, no una serie histórica por mes.
        const response = await axios.get(`${constants.urlLocal}getAgeUsersChart`)
        setChartData(response.data?.data?.ageAverage || [])
        setLabels(response.data?.data?.categories || [])
      } catch (error) {
        console.error('Error al obtener distribución de edad', error)
      }
      setLoading(false)
    }
    fetchData()
  }, [])

  const options = {
    chart: { type: 'pie' },
    labels: labels,
    colors: ['#2440ab', '#28a745', '#ffc107', '#dc3545', '#17a2b8'],
    legend: { position: 'bottom' },
  }

  const series = chartData

  if (loading)
    return (
      <div className="flex-center" style={{ height: '200px' }}>
        <PageLoader />
      </div>
    )

  return (
    <div className="card-box">
      <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem' }}>
        Distribución por Edad
      </h3>
      {chartData.length > 0 ? (
        <ReactApexChart
          options={options}
          series={series}
          type="pie"
          height={300}
        />
      ) : (
        <p style={{ textAlign: 'center', color: '#999' }}>
          No hay datos disponibles
        </p>
      )}
    </div>
  )
}
